import styles from './index.module.css'
import { Box } from '@radix-ui/themes'

import React, { useMemo } from 'react'
import type { BusinessShare } from 'types/group'
import DataTable, { Column } from 'components/ui/data-table'
import EllipsisMenu from 'components/ui/ellipsis-menu'
import TextOverflow from 'components/ui/text-overflow'
import UserAvatar from 'components/ui/user-avatar'
import {
  renderShareLastActivity,
  renderShareStatus,
  shareActionOptions,
} from './utils'
type InvitedDISCOListProps = {
  businesses: BusinessShare[]
  onResendInvite: (subdomain: string) => Promise<void>
  onRemove: (id: number, domain?: string) => Promise<void>
}
export const ShareOtherDiscosTable = ({
  businesses,
  onResendInvite,
  onRemove,
}: InvitedDISCOListProps): React.ReactNode => {
  const shareTableColumns: Column[] = useMemo(
    () => [
      {
        name: 'DISCO',
        type: 'string',
        width: 'large',
        toSortable: (prop: Record<string, any>) => prop.name,
        render: (props: Record<string, any>) => {
          return (
            <div className={styles.SharedDisco_UserAvatar__Container}>
              <div>
                <UserAvatar
                  className={styles.SharedDisco_UserAvatar__Icon}
                  name={props.name}
                  size="24px"
                  fontSize="11px"
                />
              </div>
              <TextOverflow content={props.name} />
            </div>
          )
        },
      },
      {
        name: 'Last Activity',
        type: 'date',
        width: 'medium',
        toSortable: (prop: Record<string, any>) => prop.last_activity,
        render: (props: Record<string, any>) =>
          renderShareLastActivity(props.last_activity),
      },
      {
        name: 'Status',
        type: 'numeric',
        width: 'small',
        // Status in the number order 'accepted' | 'pending' | 'left'
        toSortable: (prop: Record<string, any>) =>
          prop.status === 'accepted' ? 2 : prop.status === 'pending' ? 1 : 0,
        render: (props: Record<string, any>) => {
          return renderShareStatus(props.status)
        },
      },
      {
        render: (props: Record<string, any>) => {
          return (
            <div className={styles.SharedDisco_Actions__Menu}>
              <EllipsisMenu
                hasArrow={false}
                icon="ellipsis"
                options={shareActionOptions({
                  id: props.id,
                  status: props.status,
                  name: props.name,
                  onRemove,
                  onResendInvite,
                })}
              />
            </div>
          )
        },
        width: 'content',
      },
    ],
    [onRemove, onResendInvite],
  )
  return (
    <>
      {businesses?.length > 0 ? (
        <div className={styles.SharedDisco__Container}>
          <DataTable
            appearance="plain"
            scrollable
            columns={shareTableColumns}
            data={businesses}
            loading={false}
          />
        </div>
      ) : (
        <Box pt="18px" />
      )}
    </>
  )
}
